import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useIntl } from 'react-intl';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDFViewer = ({ id }) => {
  const intl = useIntl();

  const text = {
    loading: intl.formatMessage({
      id: 'Loading PDF…',
      defaultMessage: 'Loading PDF…',
    }),
    error: intl.formatMessage({
      id: 'Failed to load PDF file.',
      defaultMessage: 'Failed to load PDF file.',
    }),
  };

  const style = {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    backgroundColor: 'transparent',
  };

  return (
    <div style={style}>
      <Document
        file={`${process.env.SERVER_URL}/uploaded_content/academy/pdf/${id}.pdf`}
        loading={text.loading}
        error={text.error}
      >
        <Page pageNumber={1} />
      </Document>
    </div>
  );
};

export default PDFViewer;
